import dayjs from 'dayjs';
import React from 'react';

import CourseInstanceStatusBadge from '../../courseInstance/components/CourseInstanceStatusBadge';
import { CourseInstanceStatus } from '../../courseInstance/types/CourseInstance';
import { OpenClassStatus } from '../types/OpenClass';
import { isOpenClassPast } from '../utils/openClass';

const courseInstanceStatus: {
  [key in OpenClassStatus]: CourseInstanceStatus;
} = {
  [OpenClassStatus.Canceled]: CourseInstanceStatus.Canceled,
  [OpenClassStatus.Preliminary]: CourseInstanceStatus.Preliminary,
  [OpenClassStatus.Confirmed]: CourseInstanceStatus.Confirmed,
  [OpenClassStatus.Ordered]: CourseInstanceStatus.Ordered,
};

const OpenClassStatusBadge: React.FC<{
  status: OpenClassStatus;
  endAt?: string | null;
}> = ({ status, endAt }) => (
  <CourseInstanceStatusBadge
    status={courseInstanceStatus[status]}
    endsAt={isOpenClassPast(endAt) ? dayjs(endAt) : undefined}
  />
);

export default OpenClassStatusBadge;
